import React, { PropsWithChildren } from 'react';
import { ExternalUrlItem } from 'app/area/external-url-groups/form/types-store';
import { ButtonTertiary } from 'ui';
import { toManageExternalUrl } from 'app/area/shared/navigation';
import { ExternalUrlGroupsTranslation } from 'app/area/external-url-groups/constants';
import styles from './external-url-manage-url.scss';


export const ExternalUrlManageUrl = ({
  externalUrlItem, translation
}: PropsWithChildren<{
  externalUrlItem: ExternalUrlItem;
  translation: ExternalUrlGroupsTranslation;
}>) => {

  const onManageExternalUrl = () => {
    toManageExternalUrl(externalUrlItem.code?.value);
  };

  return <ButtonTertiary
    classNames={styles.manageUrlButton}
    onClick={onManageExternalUrl}>
    {translation.external_url_manage_url}
  </ButtonTertiary>;
};
